import backendHttpClient from '@services/_httpClient/backend.http-client';

import type { UploadDocumentPayload } from './dtos/upload.dto';
import type { DocumentRepository } from './repository';
import type {
  UploadDocumentOutput,
  UploadDocumentResponse,
} from './types/upload.type';

class DocumentService implements DocumentRepository {
  public async upload(
    payload: UploadDocumentPayload,
  ): Promise<UploadDocumentOutput> {
    const formData = new FormData();

    formData.append('file', payload.file);

    const { data } = await backendHttpClient.post<
      UploadDocumentResponse,
      FormData
    >({
      path: 'uploads/images',
      body: formData,
    });

    return {
      document: data,
    };
  }
}

export const documentService = new DocumentService();
